import { Component, ChangeDetectionStrategy, Output, EventEmitter, ViewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { AiAdvancedSearchResponse } from "./s25.chatbot.service";
import { S25ChatbotComponent } from "./s25.chat.bot.component";

@TypeManagerDecorator("s25-ng-ai-search-chatbot")
@Component({
    selector: "s25-ng-ai-search-chatbot",
    template: `
        <s25-ng-ai-chatbot
            #chatbot
            [welcomeMessage]="
                'Provide details on what you are looking for and I can help you get started on a SeriesQL query.'
            "
            [mode]="'sidebar'"
            [title]="'AI Query Chat'"
            [serviceConfig]="'advancedSearch'"
            (responseReceived)="onResponseReceived($event)"
        ></s25-ng-ai-chatbot>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, S25ChatbotComponent],
    standalone: true,
})
export class S25AiSearchChatbotComponent {
    @ViewChild("chatbot") chatbot!: S25ChatbotComponent<"advancedSearch">;

    constructor() {}

    onResponseReceived(response: AiAdvancedSearchResponse) {
        // const placeholderRegex = /\([^()]+\)/g;
        // const hasPlaceholders = placeholderRegex.test(response.query);
        if (response.chatResponse) {
            this.chatbot.addResponse(response.chatResponse);
            // this.chatbot.aiStore.pushAction({ actionType: "searchQuery", payload: response.querySegments });
        } else {
            this.chatbot.throwError();
        }

        if (response.querySegments) {
            let combinedQuery =
                "::" + response.querySegments.map((qs) => `${qs.term} ${qs.operator} ${qs.value}`).join(" and ");
            console.log(combinedQuery);
        }
    }
}
